import { EntityPresenterV2Mode, isStaticMode } from './presenterV2EntityMode';

import type { Maybe } from '@nova/core';
import type { CarrierCompanyDetails, CarrierUserDetails } from './carrierPresenterV2Shared';

export function nestedCompanyPresenterDataProps(
  mode: EntityPresenterV2Mode,
  data: { carrier?: Maybe<CarrierUserDetails>; company?: Maybe<CarrierCompanyDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticCarrierData: data.carrier ?? null,
      staticCompanyData: data.company ?? null
    };
  }

  return {
    placeholderCarrierData: data.carrier ?? null,
    placeholderCompanyData: data.company ?? null
  };
}
